function checkWindow(): boolean {
  return typeof window !== 'undefined'
}

export const hasWindow = checkWindow()
